<div>
    Deseja recriar a conexão <strong>{{updateData.connection.connectionId}}</strong>? Essa ação fará com que seja necessário escanear o QR Code novamente.
    <div class="mt-2 d-flex gap-2">
        <button (click)="confirm()" class="btn btn-primary">Confirmar</button>
        <button (click)="cancel()" class="btn btn-danger">Cancelar</button>
    </div>
</div>
